import axiosClient from "./axiosClient";

class AuthApi {
  login = (data: { phone: string; password: string }) => {
    const url = "/auth/login";
    return axiosClient.post(url, data);
  };
}

const authApi = new AuthApi();

export default authApi;
